import { render, staticRenderFns } from "./AddWhatsappTemplate.vue?vue&type=template&id=2cca87c4&scoped=true&"
import script from "./AddWhatsappTemplate.vue?vue&type=script&lang=js&"
export * from "./AddWhatsappTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddWhatsappTemplate.vue?vue&type=style&index=0&id=2cca87c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca87c4",
  null
  
)

export default component.exports